export const PORTFOLIO_PATH = '/portfolio';
export const USER_PROFILE_PATH = '/profile';
export const CONTACT_PATH = '/kontakt';
export const USER_REGISTER_PATH = '/register';
export const USER_LOGIN_PATH = '/login';
export const HOMEPAGE_PATH = '/startseite';
export const DASHBOARD_PATH = '/dashboard';
export const NOT_FOUND_PATH = '/not-found';
export const IMPRINT_PATH = '/impressum';
export const PRIVACY_POLICY_PATH = '/datenschutz';
export const CONDITIONS_PATH = '/nutzerbedingungen';
export const TEST_ID_HARDCODED_DASHBOARD =
	'/location_5e9a95b6-7c7c-4a33-8251-3a87bca5420c_01791ca7-b307-44df-a9e7-53740e013b07_2016';
